// src/components/Player.jsx
import React, { useEffect, useState } from 'react';
import playerSvg from './gameObtacles/trueplayer.png';
import playerSound from './sounds/gamesound.mp3'; // add the player sound file

const Player = ({ x, y,soundEnabled  }) => {
  const [playerAudio, setPlayerAudio] = useState(new Audio(playerSound));
  const playerSize = window.innerWidth < 600 ? 40 : 80; 

  useEffect(() => {
    if (soundEnabled) {
      playerAudio.loop = true;
      playerAudio.volume = 1.0;
      playerAudio.play();
    } else {
      playerAudio.pause();
      playerAudio.currentTime = 0;
    }
  }, [soundEnabled, playerAudio]);

  return (
    <img
      src={playerSvg}
      alt="Player"
      style={{
        position: 'absolute',
        left: `${x}px`,
        top: `${y}px`,
        width: `${playerSize}px`,
        height: `${playerSize}px`,
        pointerEvents: 'none'
      }}
    />
  );
};

export default Player;